<template>
    <div>
        <!--  BEGIN NAVBAR  -->
        <div class="header-container fixed-top">
            <header class="header  navbar navbar-expand-sm bg-white navbar-light" >
                <div class="navbar-item flex-row ms-md-0 ms-auto">
                    <ul class="navbar-item theme-brand flex-row text-center">
                        <li class="nav-item theme-logo">
                            <router-link to="/">
                              <!-- <h4 class="fw-bolder mobile-hidden">COPEX CONTRACTORS ERP</h4>   -->
                                <img :src="require(`@/assets/images/logo.png`)" class="navbar-logo" alt="logo" style="width: 50px; height: auto;" />
                            </router-link>
                        </li>
                    </ul>
                </div>
             
                <div class="d-none vertical-menu">
                    <a href="javascript:void(0);" class="sidebarCollapse" data-placement="bottom" @click="$store.commit('toggleSideBar', !$store.state.is_show_sidebar)">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="feather feather-menu"
                        >
                            <line x1="3" y1="12" x2="21" y2="12"></line>
                            <line x1="3" y1="6" x2="21" y2="6"></line>
                            <line x1="3" y1="18" x2="21" y2="18"></line>
                        </svg>
                    </a>
                </div>


                <!-- <div  class="navbar-item flex-row ms-md-4 ms-auto">
                    <ul class="navbar-item flex-row ms-md-0 ms-auto">
                        <li class="nav-item align-self-center search-animated" :class="{ 'show-search': $store.state.is_show_search }">
                            <svg
                                @click="$store.commit('toggleSearch', !$store.state.is_show_search)"
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-search toggle-search"
                            >
                                <circle cx="11" cy="11" r="8"></circle>
                                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                            </svg>
                            <form class="form-inline search-full form-inline search" :class="{ 'input-focused': $store.state.is_show_search }">
                                <div class="search-bar">
                                    <input type="text" class="form-control search-form-control ms-lg-auto" placeholder="Search..." />
                                </div>
                            </form>
                        </li>
                    </ul>
                </div> -->

                <div class="navbar-item flex-row ms-md-auto ">
                   
<!-- notification starts -->
 
                    <div class="dropdown nav-item notification-dropdown btn-group">

        <!-- Dashboard notifications starts -->
<div class="dropdown nav-item notification-dropdown btn-group" style="position: relative;" ref="notifDropdownRef">
               <div class="d-flex align-items-center gap-3">

                             <button 
                                class="btn btn-primary refresh-btn rounded-circle p-2" 
                                @click="refreshPage" 
                                title="Refresh page"
                                :class="{ 'spin-animation': isRefreshing }"
                                :disabled="isRefreshing"
                                style="width: 2.5rem; height: 2.5rem;"
                            >
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    width="16" 
                                    height="16" 
                                    fill="currentColor" 
                                    class="bi bi-arrow-clockwise" 
                                    viewBox="0 0 16 16"
                                >
                                    <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                                    <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                                </svg>
                            </button>
                            <button class="btn btn-link position-relative" @click.stop="showNotif = !showNotif">
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="red" class="bi bi-bell vibrate" viewBox="0 0 16 16">
          <path d="M8 16a2 2 0 0 0 1.985-1.75H6.015A2 2 0 0 0 8 16zm.104-14.804a1 1 0 0 0-1.208 0A5.002 5.002 0 0 0 3 6c0 1.098-.628 2.064-1.528 2.625A.5.5 0 0 0 2 9.5h12a.5.5 0 0 0 .528-.875C13.628 8.064 13 7.098 13 6a5.002 5.002 0 0 0-3.896-4.804z"/>
        </svg>
        <span class="position-absolute top-0 start-100 translate-middle">
          <span class="bg-danger rounded-circle" style="width: 8px; height: 8px; display: inline-block;"></span>
        </span>
      </button>
        </div>
  <div v-if="showNotif" class="card shadow" style="position: absolute; right: 0; top: 100%; min-width: 260px; max-width: 320px; z-index: 1000;">
    <div class="card-header bg-light text-dark">
      <h6 class="mb-0">Dashboard Status</h6>
    </div>
    <div class="card-body p-3" style="max-height: 80vh; overflow-y: auto;">
      <div v-if="summary">
        
        <template v-if="summary.lpo?.unapproved > 0">
          <div class="mb-3">
            <div class="d-flex justify-content-between align-items-center" :class="{ 'cursor-pointer': user_permissions.includes('can_view_lpo_card') }" 
              :data-bs-toggle="user_permissions.includes('can_view_lpo_card') ? 'modal' : null"
              :data-bs-target="user_permissions.includes('can_view_lpo_card') ? '#header-lpos' : null"
              @click="user_permissions.includes('can_view_lpo_card') ? getHeaderLpo('status_name=Unapproved') : null">
              <span class='text-dark'>LPOs</span>
              <span class="badge bg-danger text-light fs-6">{{ summary.lpo?.unapproved }}</span>
            </div>
          </div>
          <hr class="border-2 border-dark">
        </template>
        
        <template v-if="summary.grn?.unapproved > 0">
          <div class="mb-3">
            <div class="d-flex justify-content-between align-items-center" :class="{ 'cursor-pointer': user_permissions.includes('can_view_grn_card') }" 
              :data-bs-toggle="user_permissions.includes('can_view_grn_card') ? 'modal' : null"
              :data-bs-target="user_permissions.includes('can_view_grn_card') ? '# header-grns' : null"
              @click="user_permissions.includes('can_view_grn_card') ? getHeaderGrn() : null">
              <span class='text-dark'>Pending GRNs</span>
              <span class="badge bg-warning text-light fs-6">{{ summary.grn?.unapproved }}</span>
            </div>
          </div>
          <hr class="border-2 border-dark">
        </template>
        
        <template v-if="summary.material_requisition?.pending > 0">
          <div class="mb-3">
            <div class="d-flex justify-content-between align-items-center" :class="{ 'cursor-pointer': user_permissions.includes('can_view_material_requisition_card') }" 
              :data-bs-toggle="user_permissions.includes('can_view_material_requisition_card') ? 'modal' : null"
              :data-bs-target="user_permissions.includes('can_view_material_requisition_card') ? '#header-requisitions' : null"
              @click="user_permissions.includes('can_view_material_requisition_card') ? getHeaderRequisitions('status_id=2') : null">
              <span class='text-dark'>Requisitions</span>
              <span class="badge bg-warning text-light fs-6">{{ summary.material_requisition?.pending }}</span>
            </div>
          </div>
          <hr class="border-2 border-dark">
        </template>
        
        <!-- <template v-if="summary.labour_request?.unapproved > 0">
          <div class="mb-3">
            <div class="d-flex justify-content-between align-items-center">
              <span class='text-dark'>Labour Requests</span>
              <span class="badge bg-danger text-light fs-6">{{ summary.labour_request?.unapproved }}</span>
            </div>
          </div>
          <hr class="border-2 border-dark">
        </template> -->
      </div>
      
      <div v-else class="text-center text-muted">
        No summary data available
      </div>
    </div>
  </div>
</div>
        <!-- Dashboard notifications ends -->

                <!-- LPO modal starts -->
<div class="modal fade mymodal" id="header-lpos" data-bs-backdrop="false" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-scrollable"> <!-- Add scrollable class -->
    <div class="modal-content" style="max-height: 95vh; display: flex; flex-direction: column;">
      
      <!-- Fixed Header -->
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="staticBackdropLabel">LPOs</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close_lpo"></button>
      </div>

      <!-- Scrollable Body -->
      <div class="modal-body flex-grow-1 overflow-auto">
        <div class="row layout-top-spacing">
          <div class="col-xl-12 col-lg-12 col-sm-12 layout-spacing">
            <div class="panel p-0">
              <div class="custom-table table3">
                <v-client-table :data="Headerlpos" :columns="HeaderlpoColumns" >
                  <template #status="props">
                    <span class="badge inv-status" :class="'badge-' + props.row.status.color">
                      {{ props.row.status.name }}
                    </span>
                  </template>
                   <template #check="props">
                  <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          :checked="orders.includes(props.row.id)"
          @change="triggerOrder(props.row.id, $event.target.checked)"
        >
      </div>
                  </template>
                    <template #approve="props">
                    <button class="btn btn-primary btn-sm p-2"
                    v-if="props.row.awaits === 'MD'"
                     @click="approveCheck(props.row.approval_id, 'managing_director')"
                    >
                   <div v-if="spinner === props.row.approval_id " class="spinner-border text-white" role="status">
                                         <span class="sr-only"></span>
                                        </div>
                                        <div v-else>Approve</div>
                  </button>

                    <button class="btn btn-dark btn-sm p-2"
                    v-if="props.row.awaits === 'No one'"
                     @click="approveUncheck(props.row.approval_id, 'managing_director',props.row.id)"
                    >
                   <div v-if="spinner === props.row.approval_id " class="spinner-border text-white" role="status">
                                         <span class="sr-only"></span>
                                        </div>
                                        <div v-else>Unapprove </div>
                  </button>
                    </template>
                </v-client-table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Fixed Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary"
        v-if="orders.length != 0 "
        >Approve</button>
      </div>
    </div>
  </div>
</div>
        <!-- LPO modal ends -->

            <!-- grn modal starts  -->
       <div class="modal fade mymodal " id="header-grns" data-bs-backdrop="false" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog  modal-xl modal-dialog-scrollable"> <!-- Add scrollable class -->
    <div class="modal-content" style="max-height: 95vh; display: flex; flex-direction: column;">
      
      <!-- Fixed Header -->
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="staticBackdropLabel">Pending GRNs</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Scrollable Body -->
      <div class="modal-body flex-grow-1 overflow-auto">
        <div class="row layout-top-spacing">
          <div class="col-xl-12 col-lg-12 col-sm-12 layout-spacing">
            <div class="panel p-0">
              <div class="custom-table table3">
                <v-client-table :data="headergrns" :columns="headergrnColumns" >
                </v-client-table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Fixed Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary"
         :class="{ disabled: orders.length === 0 }"
        >Check</button>
      </div>
    </div>
  </div>
</div>
        <!-- grn modal ends -->

          <!-- requisition modal starts -->
                           <div class="modal fade mymodal " id="header-requisitions" data-bs-backdrop="false" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog  modal-fullscreen modal-dialog-scrollable"> <!-- Add scrollable class -->
    <div class="modal-content" style="max-height: 95vh; display: flex; flex-direction: column;">
      
      <!-- Fixed Header -->
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="staticBackdropLabel">Requisitions</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
        @click="closeHeaderModal()"
        ></button>
      </div>

      <div 
      class="d-flex justify-content-center my-3">
        <div
        v-if="selectedHeaderRequisition && headerrequisition_status === 'Unapproved'"
        class="btn-group" role="group" aria-label="Approve or Reject">
          <button class="btn btn-primary me-2"
          @click="approveHeaderRequisition()"
            :disabled="spinner==='approving'"
          >
         <div v-if="spinner === 'approving'" class="spinner-border text-white" role="status">
                                         <span class="sr-only"></span>
             </div>
                                        <div v-else>Approve</div>
        </button>
          <button class="btn btn-danger"
          @click="headerrejection = !headerrejection "
          :disabled="spinner === 'rejecting'"
          >
            <div v-if="spinner === 'rejecting'" class="spinner-border text-white" role="status">
                                         <span class="sr-only"></span>
             </div>
                                        <div v-else>Reject</div>
          </button>
        </div>
      </div>
       <div
       v-if="headergeneralTotal > 0"
       class="d-flex justify-content-center ">
        <h6 class="fw-bolder shadow p-2">Total : {{ headergeneralTotal.toLocaleString() }}/=</h6>
      </div>
      <div
      v-if="headerrejection"
      class="row justify-content-center">
        <div class="col-12 col-md-10 col-lg-8">
          <form
          @submit.prevent="rejectHeaderRequisition()"
          class="d-flex flex-column flex-sm-row gap-2" style="gap: 0.5rem;">
        <input type="text" class="form-control flex-grow-1" placeholder="Enter Rejection remark" v-model="headerremark">
        <button type="submit" class="btn btn-primary">Send </button>
          </form>
        </div>
      </div>

      <!-- Scrollable Body -->
      <div class="modal-body flex-grow-1 overflow-auto">
        <div class="row layout-top-spacing">
          <div class="col-xl-6 col-lg-12 col-sm-12 layout-spacing">
            <div class="panel p-0">
              <div class="custom-table table3">
                <v-client-table :data="headerRequisitions" :columns="headerRequisitionsColumns" >
                  <template #status="props">
                    <span class="badge inv-status" :class="'badge-' + props.row.status.color">
                      {{ props.row.status.name }}
                    </span>
                  </template>
                                 <template #actions="props">
                    <span
                    class="text-success"
                     @click="fillHeaderRequisition(props.row)"
                    >
<svg
 v-if="props.row.id === selectedHeaderRequisition"
xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
  <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
  <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
</svg>
                 <svg
                     v-else
                       xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-circle" viewBox="0 0 16 16">
  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
</svg>

                    </span>
                  </template>
                </v-client-table>
              </div>
            </div>
          </div>

          <div class="col-xl-6 col-lg-12 col-sm-12 layout-spacing">
            <div class="panel p-5">
              <div class="custom-table table3">
                <v-client-table :data="headerrequisitionItems" :columns="headerrequisitionItemColumns" >
                  <template #status="props">
                    <span class="badge inv-status" :class="'badge-' + props.row.status.color">
                      {{ props.row.status.name }}
                    </span>
                  </template>

    

                </v-client-table>
              </div>
                           <!-- attachment starts -->
                             <img v-if="headerattachment" :src="headerattachment" class="img-fluid"/>
               <!-- attachment ends -->
            </div>
          </div>
        </div>
      </div>

      <!-- Fixed Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
         @click="closeHeaderModal()"
        >Close</button>
      </div>
    </div>
  </div>
</div>
           <!-- requisition modal ends -->

                        <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="ddlnotify">
                            <li role="presentation">
                                <a href="javascript:;" class="dropdown-item">
                                    <div class="media server-log">
                                        <div class="media-aside align-self-start">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                class="feather feather-server"
                                            >
                                                <rect x="2" y="2" width="20" height="8" rx="2" ry="2"></rect>
                                                <rect x="2" y="14" width="20" height="8" rx="2" ry="2"></rect>
                                                <line x1="6" y1="6" x2="6" y2="6"></line>
                                                <line x1="6" y1="18" x2="6" y2="18"></line>
                                            </svg>
                                        </div>
                                        <div class="media-body">
                                            <div class="data-info">
                                                <h6 class="">Server Rebooted</h6>
                                                <p class="">45 min ago</p>
                                            </div>

                                            <div class="icon-status">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                    class="feather feather-x"
                                                >
                                                    <line x1="18" y1="6" x2="6" y2="18"></line>
                                                    <line x1="6" y1="6" x2="18" y2="18"></line>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </li>
                            <li role="presentation"><hr role="separator" aria-orientation="horizontal" size="0" class="dropdown-divider" /></li>
                  
                            <li role="presentation"><hr role="separator" aria-orientation="horizontal" size="0" class="dropdown-divider" /></li>
                            <li role="presentation">
                                <a href="javascript:;" class="dropdown-item">
                                    <div class="media file-upload">
                                        <div class="media-aside align-self-start">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                class="feather feather-file-text"
                                            >
                                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                                <polyline points="14 2 14 8 20 8"></polyline>
                                                <line x1="16" y1="13" x2="8" y2="13"></line>
                                                <line x1="16" y1="17" x2="8" y2="17"></line>
                                                <polyline points="10 9 9 9 8 9"></polyline>
                                            </svg>
                                        </div>
                                        <div class="media-body">
                                            <div class="data-info">
                                                <h6>Kelly Portfolio.pdf</h6>
                                                <p>670 kb</p>
                                            </div>
                                            <div class="icon-status">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                    class="feather feather-check"
                                                >
                                                    <polyline points="20 6 9 17 4 12"></polyline>
                                                </svg>
                                            </div>
                                        </div></div
                                ></a>
                            </li>
                        </ul>
                    </div>
 <!-- notification ends -->

                    <div class="dropdown nav-item user-profile-dropdown btn-group">
                        <a  href="javascript:;" id="ddluser" data-bs-toggle="dropdown" aria-expanded="false" class="btn dropdown-toggle btn-icon-only user nav-link">
                         
                        <strong><span class="nav-link text-dark " style="font-size: 1em; font-weight: bold;">{{ user ? user.name : "Guest" }}</span></strong>
   
                        </a>
                        <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="ddluser">
                            <li role="presentation">
                                <router-link to="/user/profile" class="dropdown-item">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="feather feather-user"
                                    >
                                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                        <circle cx="12" cy="7" r="4"></circle>
                                    </svg>
                                    Profile
                                </router-link>
                            </li>
                            <li role="presentation">
                                <a href="javascript:void(0);"  @click="signOut" class="dropdown-item">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="feather feather-log-out"
                                    >
                                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                                        <polyline points="16 17 21 12 16 7"></polyline>
                                        <line x1="21" y1="12" x2="9" y2="12"></line>
                                    </svg>
                                    Sign Out 
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </header>
        </div>
        <!--  END NAVBAR  -->
        <!--  BEGIN NAVBAR  -->
        <div class="sub-header-container">
            <header class="header navbar navbar-expand-sm">
                <a href="javascript:void(0);" class="sidebarCollapse" data-placement="bottom" @click="$store.commit('toggleSideBar', !$store.state.is_show_sidebar)">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="feather feather-menu"
                    >
                        <line x1="3" y1="12" x2="21" y2="12"></line>
                        <line x1="3" y1="6" x2="21" y2="6"></line>
                        <line x1="3" y1="18" x2="21" y2="18"></line>
                    </svg>
                </a>

                <!-- Portal vue/Teleport for Breadcrumb -->
                <div id="breadcrumb" class="vue-portal-target"></div>
            </header>
        </div>
        <!--  END NAVBAR  -->
        <!--  BEGIN TOPBAR  -->
        <div class="topbar-nav header navbar" role="banner">
            <nav class="topbar">
                <ul class="list-unstyled menu-categories" id="topAccordion">

                    <!-- header starts -->
                     <li v-if="user_permissions.includes('can_view_masters')" class="menu single-menu">
                        <a href="javascript:;" class="dropdown-toggle">
                            <div class="">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="feather feather-cpu"
                                >
                                    <rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect>
                                    <rect x="9" y="9" width="6" height="6"></rect>
                                    <line x1="9" y1="1" x2="9" y2="4"></line>
                                    <line x1="15" y1="1" x2="15" y2="4"></line>
                                    <line x1="9" y1="20" x2="9" y2="23"></line>
                                    <line x1="15" y1="20" x2="15" y2="23"></line>
                                    <line x1="20" y1="9" x2="23" y2="9"></line>
                                    <line x1="20" y1="14" x2="23" y2="14"></line>
                                    <line x1="1" y1="9" x2="4" y2="9"></line>
                                    <line x1="1" y1="14" x2="4" y2="14"></line>
                                </svg>
                                <span>{{ ('Masters') }}</span>
                            </div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-chevron-down"
                            >
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </a>
                        <ul class="collapse submenu list-unstyled">
                            <li v-if="user_permissions.includes('can_view_role_permissions_masters')"  class="sub-sub-submenu-list">
                                <a href="javascript:;">
                                    Authority
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="feather feather-chevron-right"
                                    >
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                </a>
                                <ul class="collapse list-unstyled sub-submenu">
                                    <li><router-link to="/masters/role">Roles</router-link></li>
                                    <li><router-link to="/masters/permissions">Permission</router-link></li>
                                    <li><router-link to="/masters/role-permissions">Role and Permission</router-link></li>
                                </ul>
                            </li> 
                             <li v-if="user_permissions.includes('is_programmer')"><router-link to="/masters/ai">AI</router-link></li>  
                            <li v-if="user_permissions.includes('is_programmer')"><router-link to="/masters/approval-groups">Approval Management</router-link></li>  
                            <li v-if="user_permissions.includes('is_programmer')"><router-link to="/test/approval-chains">Approval Test</router-link></li> 
                            <li v-if="user_permissions.includes('is_programmer')"><router-link to="/test/budget">Budget Test</router-link></li> 
                            <li v-if="user_permissions.includes('is_programmer')"><router-link to="/home">Dashboard</router-link></li>  
                             <li v-if="user_permissions.includes('can_view_logs_masters')"  class="sub-sub-submenu-list">
                                <a href="javascript:;">
                                    Inventory 
                                       <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="feather feather-chevron-right"
                                    >
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                </a>
                                <ul class="collapse list-unstyled sub-submenu">
                                    <li v-if="user_permissions.includes('can_view_items_masters')"><router-link to="/masters/item-categories">Category</router-link></li> 
                                    <li v-if="user_permissions.includes('can_view_items_masters')"><router-link to="/masters/items-list">Items </router-link></li>  
                                </ul>
                            </li>                     
                            <li v-if="user_permissions.includes('can_view_items_masters')"><router-link to="/masters/items-list">Items </router-link></li>
                            <li v-if="user_permissions.includes('can_view_items_masters')"><router-link to="/masters/item-categories">Items Category</router-link></li>            
                            <li v-if="user_permissions.includes('can_view_project_masters')"><router-link to="/masters/projects">Projects</router-link></li>
                            <li v-if="user_permissions.includes('can_view_service_masters')"><router-link to="/masters/service">Services</router-link></li>
                            <li v-if="user_permissions.includes('can_view_unit_masters')"><router-link to="/masters/units">Units</router-link></li>
                            <li v-if="user_permissions.includes('can_view_individual_masters')"  class="sub-sub-submenu-list">
                                <a href="javascript:;">
                                    Individuals
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="feather feather-chevron-right"
                                    >
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                </a>
                                <ul class="collapse list-unstyled sub-submenu">
                                    <li v-if="user_permissions.includes('can_view__masters')"><router-link to="/masters/employees">Employees</router-link></li>
                                    <li><router-link to="/masters/labours">Labours</router-link></li>
                                     <li><router-link to="/orders2">Orders</router-link></li>
                                    <li><router-link to="/masters/labour-type">Labour Types</router-link></li>
                                    <li><router-link to="/masters/labour-request">Labour Requests</router-link></li>
                                    <li v-if="user_permissions.includes('can_view_user_masters')"><router-link to="/masters/users">Users</router-link></li>
                                    <li><router-link to="/masters/vendors">Vendors</router-link></li>
                                </ul>
                            </li> 
                            <li v-if="user_permissions.includes('can_view_logs_masters')"  class="sub-sub-submenu-list">
                                <a href="javascript:;">
                                    Logs
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="feather feather-chevron-right"
                                    >
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                </a>
                                <ul class="collapse list-unstyled sub-submenu">
                                    <li><router-link to="/masters/approval-check">Approval Checks</router-link></li>
                                    <li><router-link to="/logs/deleted-orders">Deleted Orders</router-link></li>   
                                    <li><router-link to="/masters/logs">Funding Logs</router-link></li>
                                    <li><router-link to="/masters/remark-records">Remark Logs</router-link></li>
                                </ul>
                            </li> 
                            <li v-if="user_permissions.includes('can_view_lpo_masters')"  class="sub-sub-submenu-list">
                                <a href="javascript:;">
                                    LPO's
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="feather feather-chevron-right"
                                    >
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                </a>
                                <ul class="collapse list-unstyled sub-submenu">
                                    <li><router-link to="/orders2">Budget Lpo</router-link></li>
                                    <li><router-link to="/masters/lpo-items">LPO items</router-link></li>
                                    <li><router-link to="/test/approval-chains">Approval Chains</router-link></li>
                                     <li><router-link to="/masters/approval-groups">Approval Groups</router-link></li>
                                </ul>
                            </li>
                            <li v-if="user_permissions.includes('can_view_machines_masters')"  class="sub-sub-submenu-list">
                                <a href="javascript:;">
                                    Machines
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="feather feather-chevron-right"
                                    >
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                </a>
                                <ul class="collapse list-unstyled sub-submenu">
                                    <li><router-link to="/masters/machines">Machine List</router-link></li>
                                    <li><router-link to="/masters/machine-type">Machine Types</router-link></li>
                                </ul>
                            </li>               
                        </ul>
                    </li>   
                    
                        <li v-if="user_permissions.includes('can_view_users')"  class="menu single-menu">
                        <router-link to="/masters/users" class="dropdown-toggle autodroprown">
                            <div class="">
<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-people-fill" viewBox="0 0 16 16">
  <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5.784 6A2.24 2.24 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.3 6.3 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1zM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"/>
</svg>      <span>{{ ('Users') }}</span>
                            </div>
                           
                        </router-link>
                     
                     </li>


                     <li v-if="user_permissions.includes('can_view_patients')"  class="menu single-menu">
                        <router-link to="/patients" class="dropdown-toggle autodroprown">
                            <div class="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-person-wheelchair" viewBox="0 0 16 16">
  <path d="M12 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m-.663 2.146a1.5 1.5 0 0 0-.47-2.115l-2.5-1.508a1.5 1.5 0 0 0-1.676.086l-2.329 1.75a.866.866 0 0 0 1.051 1.375L7.361 3.37l.922.71-2.038 2.445A4.73 4.73 0 0 0 2.628 7.67l1.064 1.065a3.25 3.25 0 0 1 4.574 4.574l1.064 1.063a4.73 4.73 0 0 0 1.09-3.998l1.043-.292-.187 2.991a.872.872 0 1 0 1.741.098l.206-4.121A1 1 0 0 0 12.224 8h-2.79zM3.023 9.48a3.25 3.25 0 0 0 4.496 4.496l1.077 1.077a4.75 4.75 0 0 1-6.65-6.65z"/>
</svg>
                                <span>{{ ('Patients') }}</span>
                            </div>
                           
                        </router-link>
                     
                     </li>

                      <li v-if="user_permissions.includes('can_view_products')"  class="menu single-menu">
                        <router-link to="/products" class="dropdown-toggle autodroprown">
                            <div class="">
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-capsule" viewBox="0 0 16 16">
  <path d="M1.828 8.9 8.9 1.827a4 4 0 1 1 5.657 5.657l-7.07 7.071A4 4 0 1 1 1.827 8.9Zm9.128.771 2.893-2.893a3 3 0 1 0-4.243-4.242L6.713 5.429z"/>
</svg>
                                <span>{{ ('Products') }}</span>
                            </div>
                           
                        </router-link>
                     
                     </li>

                     <li v-if="user_permissions.includes('can_view_companies')"  class="menu single-menu">
                        <router-link to="/company/bushman" class="dropdown-toggle autodroprown">
                            <div class="">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-building-gear" viewBox="0 0 16 16">
                                      <path d="M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6.5a.5.5 0 0 1-1 0V1H3v14h3v-2.5a.5.5 0 0 1 .5-.5H8v4H3a1 1 0 0 1-1-1z"/>
                                      <path d="M4.5 2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm-6 3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm-6 3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm4.386 1.46c.18-.613 1.048-.613 1.229 0l.043.148a.64.64 0 0 0 .921.382l.136-.074c.561-.306 1.175.308.87.869l-.075.136a.64.64 0 0 0 .382.92l.149.045c.612.18.612 1.048 0 1.229l-.15.043a.64.64 0 0 0-.38.921l.074.136c.305.561-.309 1.175-.87.87l-.136-.075a.64.64 0 0 0-.92.382l-.045.149c-.18.612-1.048.612-1.229 0l-.043-.15a.64.64 0 0 0-.921-.38l-.136.074c-.561.305-1.175-.309-.87-.87l.075-.136a.64.64 0 0 0-.382-.92l-.148-.045c-.613-.18-.613-1.048 0-1.229l.148-.043a.64.64 0 0 0 .382-.921l-.074-.136c-.306-.561.308-1.175.869-.87l.136.075a.64.64 0 0 0 .92-.382zM14 12.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0"/>
                                    </svg>
                                <span>{{ ('Bushman') }}</span>
                            </div>
                           
                        </router-link>
                     
                     </li>
                      <li v-if="user_permissions.includes('can_view_wages')"  class="menu single-menu">
                        <router-link to="/masters/labour-type" class="dropdown-toggle autodroprown">
                            <div class="">
                                
                                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-cash-coin" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M11 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8m5-4a5 5 0 1 1-10 0 5 5 0 0 1 10 0"/>
  <path d="M9.438 11.944c.047.596.518 1.06 1.363 1.116v.44h.375v-.443c.875-.061 1.386-.529 1.386-1.207 0-.618-.39-.936-1.09-1.1l-.296-.07v-1.2c.376.043.614.248.671.532h.658c-.047-.575-.54-1.024-1.329-1.073V8.5h-.375v.45c-.747.073-1.255.522-1.255 1.158 0 .562.378.92 1.007 1.066l.248.061v1.272c-.384-.058-.639-.27-.696-.563h-.668zm1.36-1.354c-.369-.085-.569-.26-.569-.522 0-.294.216-.514.572-.578v1.1zm.432.746c.449.104.655.272.655.569 0 .339-.257.571-.709.614v-1.195z"/>
  <path d="M1 0a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4.083q.088-.517.258-1H3a2 2 0 0 0-2-2V3a2 2 0 0 0 2-2h10a2 2 0 0 0 2 2v3.528c.38.34.717.728 1 1.154V1a1 1 0 0 0-1-1z"/>
  <path d="M9.998 5.083 10 5a2 2 0 1 0-3.132 1.65 6 6 0 0 1 3.13-1.567"/>
</svg>
                                <span>{{ ('Labour Wages') }}</span>
                            </div>
                        </router-link>
                      </li>
                    <li v-if="user_permissions.includes('can_view_dashboard')"  class="menu single-menu">
                        <router-link to="/home" class="dropdown-toggle autodroprown">
                            <div class="">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="feather feather-home"
                                >
                                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                                    <polyline points="9 22 9 12 15 12 15 22"></polyline>
                                </svg>
                                <span>{{ ('Dashboard') }}</span>
                            </div>
                           
                        </router-link>
                    </li> 
                                        <li v-if="user_permissions.includes('can_view_items_budget')"  class="menu single-menu">
                        <router-link to="/budgets" class="dropdown-toggle autodroprown">
                            <div class="">
                                <span>{{ ('Budget') }}</span>
                            </div>
                           
                        </router-link>
                     
                    </li>

                                                          <li v-if="user_permissions.includes('can_view_budget_analysis')"  class="menu single-menu">
                        <router-link to="/budget-analysis" class="dropdown-toggle autodroprown">
                            <div class="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-graph-up" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M0 0h1v15h15v1H0V0z"/>
  <path d="M14 10.5a.5.5 0 0 1-.5.5H10a.5.5 0 0 1-.354-.146L7.5 8.207 5.354 10.354a.5.5 0 0 1-.708 0l-2-2 .708-.708L5 9.293l2.146-2.147a.5.5 0 0 1 .708 0L10.5 10h3a.5.5 0 0 1 .5.5z"/>
</svg>

                                <span>{{ ('Budget Analysis') }}</span>
                            </div>
                           
                        </router-link>
                     
                    </li>
                        <li v-if="user_permissions.includes('can_view_requisitions')"  class="menu single-menu">
                        <router-link to="/requisitions/all" class="dropdown-toggle autodroprown">
                            <div class="">
<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-clipboard2-plus" viewBox="0 0 16 16">
  <path d="M9.5 0a.5.5 0 0 1 .5.5.5.5 0 0 0 .5.5.5.5 0 0 1 .5.5V2a.5.5 0 0 1-.5.5h-5A.5.5 0 0 1 5 2v-.5a.5.5 0 0 1 .5-.5.5.5 0 0 0 .5-.5.5.5 0 0 1 .5-.5z"/>
  <path d="M3 2.5a.5.5 0 0 1 .5-.5H4a.5.5 0 0 0 0-1h-.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1H12a.5.5 0 0 0 0 1h.5a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5z"/>
  <path d="M8.5 6.5a.5.5 0 0 0-1 0V8H6a.5.5 0 0 0 0 1h1.5v1.5a.5.5 0 0 0 1 0V9H10a.5.5 0 0 0 0-1H8.5z"/>
</svg>
                                <span>{{ ('Requisitions') }}</span>
                            </div>
                           
                        </router-link>
                     
                    </li> 
                    <li v-if="user_permissions.includes('can_view_good_issue_note')"  class="menu single-menu">
                        <router-link to="/good-issue-notes" class="dropdown-toggle autodroprown">
                            <div class="">
                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-stickies" viewBox="0 0 16 16">
  <path d="M1.5 0A1.5 1.5 0 0 0 0 1.5V13a1 1 0 0 0 1 1V1.5a.5.5 0 0 1 .5-.5H14a1 1 0 0 0-1-1z"/>
  <path d="M3.5 2A1.5 1.5 0 0 0 2 3.5v11A1.5 1.5 0 0 0 3.5 16h6.086a1.5 1.5 0 0 0 1.06-.44l4.915-4.914A1.5 1.5 0 0 0 16 9.586V3.5A1.5 1.5 0 0 0 14.5 2zM3 3.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5V9h-4.5A1.5 1.5 0 0 0 9 10.5V15H3.5a.5.5 0 0 1-.5-.5zm7 11.293V10.5a.5.5 0 0 1 .5-.5h4.293z"/>
</svg>

                                <span>{{ ('GIN') }}</span>
                            </div>
                           
                        </router-link>
                     
                    </li> 

                                          <!-- <li v-if="user_permissions.includes('can_view_lpo')"  class="menu single-menu">
                        <router-link to="/orders2" class="dropdown-toggle autodroprown">
                            <div class="">
                               <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-cart-check" viewBox="0 0 16 16">
  <path d="M11.354 6.354a.5.5 0 0 0-.708-.708L8 8.293 6.854 7.146a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0z"/>
  <path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1zm3.915 10L3.102 4h10.796l-1.313 7zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0m7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
</svg>
                                <span>{{ ('Budget LPO') }}</span>
                            </div>
                           
                        </router-link>
                     
                    </li>  -->

                <!-- <li v-if="user_permissions.includes('can_view_lpo')"  class="menu single-menu">
                        <router-link to="/general/orders" class="dropdown-toggle autodroprown">
                            <div class="">
                               <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-cart-check" viewBox="0 0 16 16">
  <path d="M11.354 6.354a.5.5 0 0 0-.708-.708L8 8.293 6.854 7.146a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0z"/>
  <path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1zm3.915 10L3.102 4h10.796l-1.313 7zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0m7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
</svg>
                                <span>{{ ('General LPO') }}</span>
                            </div>
                           
                        </router-link>
                     
                    </li>  -->

                  <li v-if="user_permissions.includes('can_view_lpo')"  class="menu single-menu">
                        <router-link to="/approval-chains/1" class="dropdown-toggle autodroprown">
                            <div class="">
                               <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-cart-check" viewBox="0 0 16 16">
  <path d="M11.354 6.354a.5.5 0 0 0-.708-.708L8 8.293 6.854 7.146a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0z"/>
  <path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1zm3.915 10L3.102 4h10.796l-1.313 7zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0m7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
</svg>
                                <span>{{ ('Purchase Orders') }}</span>
                            </div>
                           
                        </router-link>
                     
                    </li> 


                                            <li v-if="user_permissions.includes('can_view_grn')"  class="menu single-menu">
                        <router-link to="/good-received-notes/dashboard" class="dropdown-toggle autodroprown">
                            <div class="">
<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-shop-window" viewBox="0 0 16 16">
  <path d="M2.97 1.35A1 1 0 0 1 3.73 1h8.54a1 1 0 0 1 .76.35l2.609 3.044A1.5 1.5 0 0 1 16 5.37v.255a2.375 2.375 0 0 1-4.25 1.458A2.37 2.37 0 0 1 9.875 8 2.37 2.37 0 0 1 8 7.083 2.37 2.37 0 0 1 6.125 8a2.37 2.37 0 0 1-1.875-.917A2.375 2.375 0 0 1 0 5.625V5.37a1.5 1.5 0 0 1 .361-.976zm1.78 4.275a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 1 0 2.75 0V5.37a.5.5 0 0 0-.12-.325L12.27 2H3.73L1.12 5.045A.5.5 0 0 0 1 5.37v.255a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0M1.5 8.5A.5.5 0 0 1 2 9v6h12V9a.5.5 0 0 1 1 0v6h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1V9a.5.5 0 0 1 .5-.5m2 .5a.5.5 0 0 1 .5.5V13h8V9.5a.5.5 0 0 1 1 0V13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.5a.5.5 0 0 1 .5-.5"/>
</svg>
                                <span>{{ ('Good Received Notes') }}</span>
                            </div>
                           
                        </router-link>
                     
                    </li>


                                                                <li v-if="user_permissions.includes('can_view_return_notes')"  class="menu single-menu">
                        <router-link to="/stores/return-notes/all" class="dropdown-toggle autodroprown">
                            <div class="">
<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-shop-window" viewBox="0 0 16 16">
  <path d="M2.97 1.35A1 1 0 0 1 3.73 1h8.54a1 1 0 0 1 .76.35l2.609 3.044A1.5 1.5 0 0 1 16 5.37v.255a2.375 2.375 0 0 1-4.25 1.458A2.37 2.37 0 0 1 9.875 8 2.37 2.37 0 0 1 8 7.083 2.37 2.37 0 0 1 6.125 8a2.37 2.37 0 0 1-1.875-.917A2.375 2.375 0 0 1 0 5.625V5.37a1.5 1.5 0 0 1 .361-.976zm1.78 4.275a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 1 0 2.75 0V5.37a.5.5 0 0 0-.12-.325L12.27 2H3.73L1.12 5.045A.5.5 0 0 0 1 5.37v.255a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0M1.5 8.5A.5.5 0 0 1 2 9v6h12V9a.5.5 0 0 1 1 0v6h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1V9a.5.5 0 0 1 .5-.5m2 .5a.5.5 0 0 1 .5.5V13h8V9.5a.5.5 0 0 1 1 0V13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.5a.5.5 0 0 1 .5-.5"/>
</svg>
                                <span>{{ ('Return  Notes') }}</span>
                            </div>
                           
                        </router-link>
                     
                    </li>

                                            <li v-if="user_permissions.includes('can_view_delivery_notes')"  class="menu single-menu">
                        <router-link to="/good-delivery-notes" class="dropdown-toggle autodroprown">
                            <div class="">
                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-box-fill" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M15.528 2.973a.75.75 0 0 1 .472.696v8.662a.75.75 0 0 1-.472.696l-7.25 2.9a.75.75 0 0 1-.557 0l-7.25-2.9A.75.75 0 0 1 0 12.331V3.669a.75.75 0 0 1 .471-.696L7.443.184l.004-.001.274-.11a.75.75 0 0 1 .558 0l.274.11.004.001zm-1.374.527L8 5.962 1.846 3.5 1 3.839v.4l6.5 2.6v7.922l.5.2.5-.2V6.84l6.5-2.6v-.4l-.846-.339Z"/>
</svg>
                                <span>{{ ('Delivery Note') }}</span>
                            </div>
                           
                        </router-link>
                     
                    </li>




                       <li v-if="user_permissions.includes('can_view_stores')" class="menu single-menu">
                        <router-link to="/stores/dashboard" class="dropdown-toggle autodroprown">
                            <div class="">
<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-gear-wide-connected" viewBox="0 0 16 16">
  <path d="M7.068.727c.243-.97 1.62-.97 1.864 0l.071.286a.96.96 0 0 0 1.622.434l.205-.211c.695-.719 1.888-.03 1.613.931l-.08.284a.96.96 0 0 0 1.187 1.187l.283-.081c.96-.275 1.65.918.931 1.613l-.211.205a.96.96 0 0 0 .434 1.622l.286.071c.97.243.97 1.62 0 1.864l-.286.071a.96.96 0 0 0-.434 1.622l.211.205c.719.695.03 1.888-.931 1.613l-.284-.08a.96.96 0 0 0-1.187 1.187l.081.283c.275.96-.918 1.65-1.613.931l-.205-.211a.96.96 0 0 0-1.622.434l-.071.286c-.243.97-1.62.97-1.864 0l-.071-.286a.96.96 0 0 0-1.622-.434l-.205.211c-.695.719-1.888.03-1.613-.931l.08-.284a.96.96 0 0 0-1.186-1.187l-.284.081c-.96.275-1.65-.918-.931-1.613l.211-.205a.96.96 0 0 0-.434-1.622l-.286-.071c-.97-.243-.97-1.62 0-1.864l.286-.071a.96.96 0 0 0 .434-1.622l-.211-.205c-.719-.695-.03-1.888.931-1.613l.284.08a.96.96 0 0 0 1.187-1.186l-.081-.284c-.275-.96.918-1.65 1.613-.931l.205.211a.96.96 0 0 0 1.622-.434zM12.973 8.5H8.25l-2.834 3.779A4.998 4.998 0 0 0 12.973 8.5m0-1a4.998 4.998 0 0 0-7.557-3.779l2.834 3.78zM5.048 3.967l-.087.065zm-.431.355A4.98 4.98 0 0 0 3.002 8c0 1.455.622 2.765 1.615 3.678L7.375 8zm.344 7.646.087.065z"/>
</svg>
                                <span>{{ ('Stores') }}</span>
                            </div>
                           
                        </router-link>
                     
                    </li>

                                           <li v-if="user_permissions.includes('can_view_work_report')" class="menu single-menu">
                        <router-link to="/report/workReport" class="dropdown-toggle autodroprown">
                            <div class="">

                                <span>{{ ('Work Report') }}</span>
                            </div>
                           
                        </router-link>
                     
                    </li>

                    <li v-if="user_permissions.includes('can_view_bulk')" class="menu single-menu">
                        <router-link to="/bulk-statements" class="dropdown-toggle autodroprown">
                            <div class="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" class="bi bi-fuel-pump" viewBox="0 0 16 16">
  <path d="M3 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5z"/>
  <path d="M1 2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v8a2 2 0 0 1 2 2v.5a.5.5 0 0 0 1 0V8h-.5a.5.5 0 0 1-.5-.5V4.375a.5.5 0 0 1 .5-.5h1.495c-.011-.476-.053-.894-.201-1.222a.97.97 0 0 0-.394-.458c-.184-.11-.464-.195-.9-.195a.5.5 0 0 1 0-1q.846-.002 1.412.336c.383.228.634.551.794.907.295.655.294 1.465.294 2.081v3.175a.5.5 0 0 1-.5.501H15v4.5a1.5 1.5 0 0 1-3 0V12a1 1 0 0 0-1-1v4h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1zm9 0a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v13h8z"/>
</svg>
                                <span>{{ ('Bulk Statement') }}</span>
                            </div>
                           
                        </router-link>
                    </li>
                    <li v-if="user_permissions.includes('can_view_direct_fill')" class="menu single-menu">
                        <router-link to="/direct-filling" class="dropdown-toggle autodroprown">
                            <div class="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" class="bi bi-fuel-pump" viewBox="0 0 16 16">
                                   <path d="M3 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5z"/>
                                   <path d="M1 2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v8a2 2 0 0 1 2 2v.5a.5.5 0 0 0 1 0V8h-.5a.5.5 0 0 1-.5-.5V4.375a.5.5 0 0 1 .5-.5h1.495c-.011-.476-.053-.894-.201-1.222a.97.97 0 0 0-.394-.458c-.184-.11-.464-.195-.9-.195a.5.5 0 0 1 0-1q.846-.002 1.412.336c.383.228.634.551.794.907.295.655.294 1.465.294 2.081v3.175a.5.5 0 0 1-.5.501H15v4.5a1.5 1.5 0 0 1-3 0V12a1 1 0 0 0-1-1v4h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1zm9 0a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v13h8z"/>
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" class="bi bi-truck-front" viewBox="0 0 16 16">
  <path d="M5 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0m8 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-6-1a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2zM4 2a1 1 0 0 0-1 1v3.9c0 .625.562 1.092 1.17.994C5.075 7.747 6.792 7.5 8 7.5s2.925.247 3.83.394A1.008 1.008 0 0 0 13 6.9V3a1 1 0 0 0-1-1zm0 1h8v3.9q0 .002 0 0l-.002.004-.005.002h-.004C11.088 6.761 9.299 6.5 8 6.5s-3.088.26-3.99.406h-.003l-.005-.002L4 6.9q0 .002 0 0z"/>
  <path d="M1 2.5A2.5 2.5 0 0 1 3.5 0h9A2.5 2.5 0 0 1 15 2.5v9c0 .818-.393 1.544-1 2v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V14H5v1.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a2.5 2.5 0 0 1-1-2zM3.5 1A1.5 1.5 0 0 0 2 2.5v9A1.5 1.5 0 0 0 3.5 13h9a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 12.5 1z"/>
</svg>
                                <span>{{ ('Direct Filling') }}</span>
                            </div>
                           
                        </router-link>
                    </li>    
                    <li v-if="user_permissions.includes('can_view_assets')" class="menu single-menu">
                        <a href="javascript:;" class="dropdown-toggle">
                            <div class="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" class="bi bi-truck-front" viewBox="0 0 16 16">
  <path d="M5 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0m8 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-6-1a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2zM4 2a1 1 0 0 0-1 1v3.9c0 .625.562 1.092 1.17.994C5.075 7.747 6.792 7.5 8 7.5s2.925.247 3.83.394A1.008 1.008 0 0 0 13 6.9V3a1 1 0 0 0-1-1zm0 1h8v3.9q0 .002 0 0l-.002.004-.005.002h-.004C11.088 6.761 9.299 6.5 8 6.5s-3.088.26-3.99.406h-.003l-.005-.002L4 6.9q0 .002 0 0z"/>
  <path d="M1 2.5A2.5 2.5 0 0 1 3.5 0h9A2.5 2.5 0 0 1 15 2.5v9c0 .818-.393 1.544-1 2v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V14H5v1.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a2.5 2.5 0 0 1-1-2zM3.5 1A1.5 1.5 0 0 0 2 2.5v9A1.5 1.5 0 0 0 3.5 13h9a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 12.5 1z"/>
</svg>
                                <span>{{ ('Assets') }}</span>
                            </div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-chevron-down"
                            >
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </a>
                        <ul class="collapse submenu list-unstyled">
                            <li v-if="user_permissions.includes('can_view_machines')"><router-link to="/assets/machines">Machines</router-link></li>
                            <li v-if="user_permissions.includes('can_view_spares')"><router-link to="/assets/spares">Spares </router-link></li>
                        </ul>
                    </li>
                    <li  v-if="user_permissions.includes('can_view_jobcard')" class="menu single-menu">
                        <router-link to="/jobcards" class="dropdown-toggle autodroprown">
                            <div class="">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="feather feather-briefcase"
                                >
                                    <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                                    <path d="M16 3H8a2 2 0 0 0-2 2v2h12V5a2 2 0 0 0-2-2z"></path>
                                </svg>
                                
                                <span>{{ ('jobcards') }}</span>
                            </div>
                                 <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-chevron-down"
                            >
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                           
                              <ul class="collapse submenu list-unstyled">
                            <li ><router-link to="/jobcards">Jobcard List</router-link></li>
                            <li ><router-link to="/jobcards/asset-consumption">Asset Jobcards</router-link></li>
                    
                            </ul>
                        </router-link>                    
                    </li>

                         <li  v-if="user_permissions.includes('can_view_jobcard')" class="menu single-menu">
                        <router-link to="/jobcards/outside-maintenances" class="dropdown-toggle autodroprown">
                            <div class="">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="feather feather-briefcase"
                                >
                                    <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                                    <path d="M16 3H8a2 2 0 0 0-2 2v2h12V5a2 2 0 0 0-2-2z"></path>
                                </svg>
                                
                                <span>{{ ('Outside Maintenance') }}</span>
                            </div>
                        </router-link>                    
                    </li>

                                        <li v-if="user_permissions.includes('can_view_spares')" class="menu single-menu">
                        <router-link to="/assets/spares" class="dropdown-toggle autodroprown">
                            <div class="">
                               <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-tools" viewBox="0 0 16 16">
  <path d="M1 0 0 1l2.2 3.081a1 1 0 0 0 .815.419h.07a1 1 0 0 1 .708.293l2.675 2.675-2.617 2.654A3.003 3.003 0 0 0 0 13a3 3 0 1 0 5.878-.851l2.654-2.617.968.968-.305.914a1 1 0 0 0 .242 1.023l3.27 3.27a.997.997 0 0 0 1.414 0l1.586-1.586a.997.997 0 0 0 0-1.414l-3.27-3.27a1 1 0 0 0-1.023-.242L10.5 9.5l-.96-.96 2.68-2.643A3.005 3.005 0 0 0 16 3q0-.405-.102-.777l-2.14 2.141L12 4l-.364-1.757L13.777.102a3 3 0 0 0-3.675 3.68L7.462 6.46 4.793 3.793a1 1 0 0 1-.293-.707v-.071a1 1 0 0 0-.419-.814zm9.646 10.646a.5.5 0 0 1 .708 0l2.914 2.915a.5.5 0 0 1-.707.707l-2.915-2.914a.5.5 0 0 1 0-.708M3 11l.471.242.529.026.287.445.445.287.026.529L5 13l-.242.471-.026.529-.445.287-.287.445-.529.026L3 15l-.471-.242L2 14.732l-.287-.445L1.268 14l-.026-.529L1 13l.242-.471.026-.529.445-.287.287-.445.529-.026z"/>
</svg>
                                <span>{{ ('Spares') }}</span>
                            </div>
                           
                        </router-link>
                     
                    </li>

                     <li v-if="user_permissions.includes('can_view_approval_chains')" class="menu single-menu">
                        <a href="javascript:;" class="dropdown-toggle">
                            <div class="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-newspaper" viewBox="0 0 16 16">
                                <path d="M0 2.5A1.5 1.5 0 0 1 1.5 1h11A1.5 1.5 0 0 1 14 2.5v10.528c0 .3-.05.654-.238.972h.738a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 1 1 0v9a1.5 1.5 0 0 1-1.5 1.5H1.497A1.497 1.497 0 0 1 0 13.5zM12 14c.37 0 .654-.211.853-.441.092-.106.147-.279.147-.531V2.5a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5v11c0 .278.223.5.497.5z"/>
                                <path d="M2 3h10v2H2zm0 3h4v3H2zm0 4h4v1H2zm0 2h4v1H2zm5-6h2v1H7zm3 0h2v1h-2zM7 8h2v1H7zm3 0h2v1h-2zm-3 2h2v1H7zm3 0h2v1h-2zm-3 2h2v1H7zm3 0h2v1h-2z"/>
                                </svg>
                                <span>{{ ('Approvals') }}</span>
                            </div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-chevron-down"
                            >
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </a>
                       <ul class="collapse submenu list-unstyled">
                            <!-- <li v-if="user_permissions.includes('can_view_bushman_voucher')"><router-link to="/vouchers/bushman">Bushman Voucher</router-link></li>
                            <li v-if="user_permissions.includes('can_view_copex_voucher')"><router-link to="/vouchers/copex">Copex Voucher </router-link></li>
                            <li v-if="user_permissions.includes('can_view_copex_lpo')"><router-link to="/lpo/copex">Copex LPO </router-link></li>
                            <li v-if="user_permissions.includes('can_view_bushman_lpo')"><router-link to="/lpo/bushman">Bushman Lpo </router-link></li>
                            <li v-if="user_permissions.includes('can_view_labour_request')"><router-link to="/labour/copex">Copex Labour Request</router-link></li>
                            <li v-if="user_permissions.includes('can_view_labour_request')"><router-link to="/labour/bushman">Bushman Labour Request</router-link></li> -->
                            <li v-if="user_permissions.includes('can_view_requisitions')">
                                <router-link to="/approval-chains/all">All Requisitions</router-link></li>
                            <li 
                            v-for="incidence in incidences"
                            v-if="user_permissions.includes('can_view_requisitions')">
                              <router-link :to="`/approval-chains/${incidence.id}`">
                                {{ incidence.name }}
                              </router-link>
                            </li>

                        </ul>

                     
                    </li>

                        <li v-if="user_permissions.includes('can_view_vouchers')" class="menu single-menu">
                        <router-link to="/approval-chains/4" class="dropdown-toggle autodroprown">
                            <div class="">
                     <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-newspaper" viewBox="0 0 16 16">
                                <path d="M0 2.5A1.5 1.5 0 0 1 1.5 1h11A1.5 1.5 0 0 1 14 2.5v10.528c0 .3-.05.654-.238.972h.738a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 1 1 0v9a1.5 1.5 0 0 1-1.5 1.5H1.497A1.497 1.497 0 0 1 0 13.5zM12 14c.37 0 .654-.211.853-.441.092-.106.147-.279.147-.531V2.5a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5v11c0 .278.223.5.497.5z"/>
                                <path d="M2 3h10v2H2zm0 3h4v3H2zm0 4h4v1H2zm0 2h4v1H2zm5-6h2v1H7zm3 0h2v1h-2zM7 8h2v1H7zm3 0h2v1h-2zm-3 2h2v1H7zm3 0h2v1h-2zm-3 2h2v1H7zm3 0h2v1h-2z"/>
                                </svg>
                                <span>{{ ('Vouchers') }}</span>
                            </div>
                           
                        </router-link>
                     
                    </li>
                    
                    <li v-if="user_permissions.includes('can_view_site_report')" class="menu single-menu">
                        <router-link to="/report/site-report" class="dropdown-toggle autodroprown">
                            <div class="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-newspaper" viewBox="0 0 16 16">
                                <path d="M0 2.5A1.5 1.5 0 0 1 1.5 1h11A1.5 1.5 0 0 1 14 2.5v10.528c0 .3-.05.654-.238.972h.738a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 1 1 0v9a1.5 1.5 0 0 1-1.5 1.5H1.497A1.497 1.497 0 0 1 0 13.5zM12 14c.37 0 .654-.211.853-.441.092-.106.147-.279.147-.531V2.5a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5v11c0 .278.223.5.497.5z"/>
                                <path d="M2 3h10v2H2zm0 3h4v3H2zm0 4h4v1H2zm0 2h4v1H2zm5-6h2v1H7zm3 0h2v1h-2zM7 8h2v1H7zm3 0h2v1h-2zm-3 2h2v1H7zm3 0h2v1h-2zm-3 2h2v1H7zm3 0h2v1h-2z"/>
                                </svg>
                                <span>{{ ('Site Report') }}</span>
                            </div>
                           
                        </router-link>
                     
                    </li>

                    <li v-if="user_permissions.includes('can_view_project_budget')"  class="menu single-menu">
                        <router-link to="/report/project-budget" class="dropdown-toggle autodroprown">
                            <div class="">
                             P-$
                                <span>{{ ('Project Budget') }}</span>
                            </div>
                           
                        </router-link>
                     
                    </li>
                    <li v-if="user_permissions.includes('can_view_boq')"  class="menu single-menu">
                        <router-link to="/report/boq" class="dropdown-toggle autodroprown">
                            <div class="">
                                <span>{{ ('BOQ') }}</span>
                            </div>
                           
                        </router-link>
                     
                    </li>
                    <li v-if="user_permissions.includes('can_view_allowance')"  class="menu single-menu">
                        <router-link to="/report/allowance" class="dropdown-toggle autodroprown">
                            <div class="">
                                <span>{{ ('Allowance') }}</span>
                            </div>
                           
                        </router-link>
                    </li>
                    <li v-if="user_permissions.includes('can_view_labour_request')"  class="menu single-menu">
                        <router-link to="/approval-chains/5" class="dropdown-toggle autodroprown">
                          
                            <div class="">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-walking" viewBox="0 0 16 16">
  <path d="M9.5 1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M6.44 3.752A.75.75 0 0 1 7 3.5h1.445c.742 0 1.32.643 1.243 1.38l-.43 4.083a1.8 1.8 0 0 1-.088.395l-.318.906.213.242a.8.8 0 0 1 .114.175l2 4.25a.75.75 0 1 1-1.357.638l-1.956-4.154-1.68-1.921A.75.75 0 0 1 6 8.96l.138-2.613-.435.489-.464 2.786a.75.75 0 1 1-1.48-.246l.5-3a.75.75 0 0 1 .18-.375l2-2.25Z"/>
  <path d="M6.25 11.745v-1.418l1.204 1.375.261.524a.8.8 0 0 1-.12.231l-2.5 3.25a.75.75 0 1 1-1.19-.914zm4.22-4.215-.494-.494.205-1.843.006-.067 1.124 1.124h1.44a.75.75 0 0 1 0 1.5H11a.75.75 0 0 1-.531-.22Z"/>
</svg>
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-bricks" viewBox="0 0 16 16">
  <path d="M0 .5A.5.5 0 0 1 .5 0h15a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H14v2h1.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H14v2h1.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5H2v-2H.5a.5.5 0 0 1-.5-.5v-3A.5.5 0 0 1 .5 6H2V4H.5a.5.5 0 0 1-.5-.5zM3 4v2h4.5V4zm5.5 0v2H13V4zM3 10v2h4.5v-2zm5.5 0v2H13v-2zM1 1v2h3.5V1zm4.5 0v2h5V1zm6 0v2H15V1zM1 7v2h3.5V7zm4.5 0v2h5V7zm6 0v2H15V7zM1 13v2h3.5v-2zm4.5 0v2h5v-2zm6 0v2H15v-2z"/>
</svg>
                                <span>{{ ('Labour Request') }}</span>
                            </div>
                           
                        </router-link>
                    </li>
                    <li v-if="user_permissions.includes('can_view_labours')"  class="menu single-menu">
                        <router-link to="/masters/labours" class="dropdown-toggle autodroprown">
                            <div class="">
                                <span>{{ ('Labours') }}</span>
                            </div>
                           
                        </router-link>
                     
                    </li>
                     <li v-if="user_permissions.includes('can_view_payment_book')"  class="menu single-menu">
                        <router-link to="/payment" class="dropdown-toggle autodroprown">
                            <div class="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-book" viewBox="0 0 16 16">
  <path d="M1 2.828c.885-.37 2.154-.769 3.388-.893 1.33-.134 2.458.063 3.112.752v9.746c-.935-.53-2.12-.603-3.213-.493-1.18.12-2.37.461-3.287.811zm7.5-.141c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783"/>
</svg>
                                <span>{{ ('Payment Book') }}</span>
                            </div>
                           
                        </router-link>
                     
                    </li>
                     <li v-if="user_permissions.includes('can_view_fund_allocation')"  class="menu single-menu">
                        <router-link to="/report/allocation" class="dropdown-toggle autodroprown">
                            <div class="">
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <path d="M12 2a10 10 0 1 0 10 10h-10V2z"/>
  <path d="M13 2.05A10 10 0 0 1 21.95 11H13V2.05z" fill="#4caf50"/>
  <text x="6" y="18" font-size="8" fill="white">$</text>
</svg>

                                <span>{{ ('Fund Allocation') }}</span>
                            </div>
                           
                        </router-link>
                     
                    </li>
                    <li 
                    v-if="user_permissions.includes('can_view_chats')" 
                    class="menu single-menu">
                        <router-link to="/chats" class="dropdown-toggle autodroprown">
                            <div class="">
                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-chat-dots" viewBox="0 0 16 16">
  <path d="M5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/>
  <path d="m2.165 15.803.02-.004c1.83-.363 2.948-.842 3.468-1.105A9 9 0 0 0 8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6a10.4 10.4 0 0 1-.524 2.318l-.003.011a11 11 0 0 1-.244.637c-.079.186.074.394.273.362a22 22 0 0 0 .693-.125m.8-3.108a1 1 0 0 0-.287-.801C1.618 10.83 1 9.468 1 8c0-3.192 3.004-6 7-6s7 2.808 7 6-3.004 6-7 6a8 8 0 0 1-2.088-.272 1 1 0 0 0-.711.074c-.387.196-1.24.57-2.634.893a11 11 0 0 0 .398-2"/>
</svg>
             
                                <span>{{ ('Chats') }}</span>
                            </div>
                           
                        </router-link>
                     
                    </li>



                   
       <!-- header ends -->    
                </ul>
            </nav>
        </div>
        <!--  END TOPBAR  -->
    </div>
</template>

<script setup>
    import { onMounted, ref,inject,computed,onBeforeUnmount } from 'vue';
    import { useRouter } from 'vue-router';
    import axios from 'axios';
    const  is_admin=ref(false);
    const  is_dataentry=ref(false);
    const router = useRouter();
    const orders = ref([]);

    const showError = inject('showError');
    const showMessage = inject('showMessage');
const notifDropdownRef = ref(null);
    const showNotif = ref(false);
const summary = ref(null);


const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL
});

function handleClickOutside(event) {
  if (
    showNotif.value &&
    notifDropdownRef.value &&
    !notifDropdownRef.value.contains(event.target)
  ) {
    showNotif.value = false;
  }
}


    const signOut = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        router.push('/'); // Redirect to login page
    };

const fetchHeaderSummary = () => {
  axiosInstance.get('dashboard/summary')
    .then(response => {
      summary.value = response.data;
    })
    .catch(error => {
      console.error('Error fetching summary :', error);
    });
};
        const HeaderlpoColumns = ref(['Sno','order','date','project','supplier','payment','requester','total','awaits','approve']);
        const Headerlpos = ref([])
        const getHeaderLpo = async (status)=>{
          axiosInstance.get(`dashboard/lpos?${status}`)
        .then(response => {
            Headerlpos.value = response.data.map((item,index) =>({
              ...item,
             Sno : index +1 ,
             order: '00'+item.id,
             date:item.date_created,
             requester: item.requested_by,
             payment:item.payment_terms,
             total:item.total_amount.toLocaleString()+'/=',
             status:{
              name:item.status_name,
              color:item.status_color,
             }
            }))
        })
        .catch(error => {
            console.error('Error fetching lpos :', error);
        });
        }
        
                const headergrnColumns = ref(['Sno','grn','order','date','project']);
        const headergrns = ref([])
        const getHeaderGrn = async ()=>{
          axiosInstance.get('dashboard/unchecked-grn')
        .then(response => {
            headergrns.value = response.data.map((item,index) =>({
              ...item,
             Sno : index +1 ,
             grn: '00'+item.id,
             order :'00'+item.order_id,
             date: item.date_created
            }))
        })
        .catch(error => {
            console.error('Error fetching lpos :', error);
        });
        }


 const selectedHeaderRequisition = ref('')
        const headerattachment = ref('')
        const headergeneralTotal = ref(0)
        const headerrequisitionItemColumns = ref(['Sno','description','quantity','rate','total']);
        const headerrequisitionItems = ref([])
        const headerrequisition_status = ref('')
        const headerremark = ref('')
        const fillHeaderRequisition = (row)=>{
             headerrequisition_status.value = row.status.name
             selectedHeaderRequisition.value = row.id
             headerattachment.value = row.attachment ? 'https://bcftrack.trustdigital.space/'+row.attachment : null
             headerrequisitionItems.value = row.items.map((item, index) => ({
             ...item,
             Sno: index + 1,
             description: item.remark,
             quantity : item.quantity,
             rate : Number(item.rate).toLocaleString() + '/=',
             total : Number(item.quantity * item.rate).toLocaleString()+'/=' 
             }))
            // Calculate general total as sum of all (quantity * rate)
            headergeneralTotal.value = headerrequisitionItems.value.reduce((sum, item) => {
              const qty = Number(item.quantity) || 0;
              // Remove '/=' and commas from rate string, then parse as number
              const rate = Number(String(item.rate).replace(/[^\d.]/g, '')) || 0;
              return sum + qty * rate;
            }, 0);
        }


    const closeHeaderModal = ()=>{
      headergeneralTotal.value=0
      selectedHeaderRequisition.value = ''
      headerrequisitionItems.value = []
      headerRequisitions.value = []
      headerattachment.value= ''
    }

    const approveHeaderRequisition = async()=>{
     spinner.value = 'approving'
     const payload= {
        status_id:3
      }
      try{
        await axiosInstance.put(`requisitions/${selectedHeaderRequisition.value}`,payload)
              showMessage("requisition Approved")
              fetchHeaderSummary()
              getHeaderRequisitions('status_id=2')
              selectedHeaderRequisition.value = ''
              spinner.value = ''
              headergeneralTotal.value = 0
      }catch(error){
          showError(error.message)
      }
    }

    const rejectHeaderRequisition = async ()=>{
      headerrejection.value=false
      spinner.value = 'rejecting'
      const payload= {
        status_id:4
      }
      const remarkPayload ={
        requisition_id: selectedHeaderRequisition.value,
        remarker_id:JSON.parse(localStorage.getItem("user")).id,
        remark:headerremark.value
      }

      try{

        await axiosInstance.post('requisition-remarks',remarkPayload)
        await axiosInstance.put(`requisitions/${selectedHeaderRequisition.value}`,payload)
              showMessage("requisition rejected")
              fetchHeaderSummary()
              getHeaderRequisitions('status_id=2')
              selectedHeaderRequisition.value = ''
              spinner.value = ''
              headergeneralTotal.value = 0
              headerattachment.value = '',
              headerrequisitionItems.value  = []
      }catch(error){
          showError(error.message)
          console.log(error)
      }

    }

     const headerrejection = ref(false)
     const clearForm = () => {
      Headerlpos.value = [];
      spinner.value = null;
     }
     const approveRequest = async (id) => {
      spinner.value = id;
      const payload = {
        status_name: 'Unapproved', 
        status_color: 'secondary',
      };
      try {
        const response = await axiosInstance.put(`purchase-orders/${id}`,payload);
        showMessage('Requisition approved successfully');
        getHeaderLpo('status_name=requisition');
        fetchHeaderSummary();
        spinner.value = null;
      } catch (error) {
        showError(error.message)
        console.error('Error approving requisition:', error);
        spinner.value = null;
      }
    }
        const headerRequisitionsColumns = ref(['Sno','type','requester','date','status','actions']);
        const headerRequisitions = ref([])
        const getHeaderRequisitions = async (id)=>{
          axiosInstance.get(`dashboard/requisitions?${id}`)
        .then(response => {
            headerRequisitions.value = response.data.map((item,index) =>({
              ...item,
             Sno : index +1 ,
             requester: item.requester,
             type: item.type,
             date: item.date,
             status:{
              name:item.status,
              color:item.status_color,
             }
            }))
        })
        .catch(error => {
            console.error('Error fetching requisition :', error);
        });
        }

           const spinner = ref('');
    const approveCheck = async (id, role) => {
      spinner.value = id;
        try {
            const response = await axiosInstance.put(`/approval-check/${id}`, {
                [role]: 1
            });
            getDashboardLpo();
            showMessage("Order approved successfully");
            spinner.value = '';
            // document.getElementById('close_lpo').click();
        } catch (error) {
            console.error("Error approving check:", error.message);
            showError("Failed to approve order");
            spinner.value = '';
        }
    };

        const approveUncheck = async (id, role,order_id) => {
      spinner.value = id;
        try {
            const response = await axiosInstance.put(`/approval-check/${id}`, {
                [role]: 0
            });
               await axiosInstance.put(`/purchase-order/${order_id}`, {
                status_name: "Unapproved",
                status_color:"secondary",
            });
            getDashboardLpo();
            spinner.value = '';
              showMessage("Order unapproved successfully");
        } catch (error) {
            console.error("Error approving check:", error.message);
            showError("Failed to Unapprove order");
            spinner.value = '';
        }
    };

    const incidences = ref([])
const getIncidences =  async () =>{
    try{
    const response = await axiosInstance.get('incidences?company_id=6')
    incidences.value = response.data
    }catch(error){
        console.log(error)
    }
   
}

       onMounted(() => {
        toggleMode();
        getIncidences()
         fetchHeaderSummary();
         getHeaderLpo('status_name=Unapproved');
         getHeaderGrn();
         getHeaderRequisitions('status_id=2');
         document.addEventListener('mousedown', handleClickOutside);
  setInterval(fetchHeaderSummary, 10000);
    });
    
    onBeforeUnmount(() => {
  document.removeEventListener('mousedown', handleClickOutside); // Clean up
});
    
    const toggleMode = (mode) => {
        window.$appSetting.toggleMode(mode);
    };

    
const user = ref(null);
const user_role = ref('');
const user_permissions = ref([]);
const isRefreshing = ref(false);
onMounted(() => {
  const storedUser = localStorage.getItem("user");
  if (!storedUser) {
    router.push('/');
  }
  if (storedUser) {
    user.value = JSON.parse(storedUser);
    user_role.value = user.value.role;
    user_permissions.value = user.value.permissions;
  }
  if(user.value.role == 1){
         is_admin.value=true;
       }
       if(user.value.role == 8){
         is_dataentry.value=true;
       }

         // Clear localStorage after 3 minutes (180000 ms)
    setTimeout(() => {
      localStorage.removeItem("user");
      router.push('/');
    }, 3600000); //clear after 30 minutes
});

const refreshPage = () => {
    window.location.reload();
};

</script>
<style>
@media (max-width: 768px) {
  .mobile-hidden {
    display: none;
  }
}

.notification-bell .notif-dropdown {
  min-width: 260px;
  max-width: 320px;
  max-height: 80vh;
  overflow-y: auto;
  border: 1px solid #eee;
  z-index: 2000;
}

        .vibrate {
      animation: vibrate 1.5s infinite;
        }
        @keyframes vibrate {
          0% { transform: translate(0); }
          25% { transform: translate(-2px, 2px); }
          50% { transform: translate(2px, -2px); }
          75% { transform: translate(-2px, -2px); }
          100% { transform: translate(2px, 2px); }
        }
    

</style>